import styled from '@emotion/styled';
import { theme } from '@/layout/GlobalStyles';

const BioPanelStyled = styled.div`
    margin-bottom: 40px;
    p:first-of-type {
        font-weight: 600;
        font-size: 20px;
        line-height: 144%;
        color: ${theme.colors.green3};
    }
    .image {
        margin-bottom: 24px;
        height: 343px;
    }
    @media ${theme.device.tablet} {
        margin-bottom: 64px;
        display: flex;
        flex-direction: column;
        .image {
            align-self: center;
            height: 543px;
            width: 80%;
            margin-bottom: 64px;
        }
    }
    @media ${theme.device.laptop} {
        display: flex;
        flex-direction: row;
        gap: 40px;
        justify-content: center;
        align-items: start;
        .image {
            flex-shrink: 0;
            width: 400px;
            height: 400px;
            margin: 0;
        }
        p:first-of-type {
            font-weight: 600;
            font-size: 24px;
            line-height: 35px;
        }
    }
`;

interface Props {
    name: string;
    bio: string;
    image: () => React.ReactNode;
}

export const BioPanel: React.FC<Props> = ({ name, bio, image }) => {
    return (
        <BioPanelStyled>
            {image()}
            <div className="copy-container">
                <p>{name}</p>
                <p>{bio}</p>
            </div>
        </BioPanelStyled>
    );
};
